import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HubAuthService } from '@core/services/hub-auth/hub-auth.service';
import { SKIP_LOGOUT } from '@core/services/hub-http/hub-http.service';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  private readonly authService = inject(HubAuthService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error.status === 401 && !this.shouldSkipLogout(request)) {
          this.authService.logout();
        }
        return throwError(() => error);
      }),
    );
  }

  /**
   * Determines whether the logout process should be skipped based on a specific condition.
   *
   * @param {HttpRequest<unknown>} request - The HTTP request object containing the context information.
   * @return {boolean} Returns true if the logout process should be skipped; otherwise, false.
   */
  private shouldSkipLogout(request: HttpRequest<unknown>): boolean {
    return request.context.get(SKIP_LOGOUT);
  }
}
